import { render } from "./SchedaVisualizzazioneGeo.vue?vue&type=template&id=f47e9268"
import script from "./SchedaVisualizzazioneGeo.vue?vue&type=script&lang=js"
export * from "./SchedaVisualizzazioneGeo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__